<div class="app-page-title">
    <div class="page-title-wrapper">
        <div class="page-title-heading">
            <div class="page-title-icon">
                <i class="{{icon}}"></i>
            </div>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item active" aria-current="page" *ngFor="let item of list">{{item.label}}</li>
                </ol>
            </nav>
        </div>
    </div>
</div>
